import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { CartProduct } from '../../../models/cart.model';
import { Resident } from '../../../models/resident.model';
import { ModalCloseButtonComponent } from '../../modal-close-button/modal-close-button.component';

@Component({
  selector: 'app-color-selection-modal',
  templateUrl: './color-selection-modal.component.html',
  styleUrls: ['./color-selection-modal.component.scss'],
  imports: [
    MatDialogModule,
    MatIconModule,
    CommonModule,
    ModalCloseButtonComponent,
  ],
})
export class ColorSelectionModalComponent {
  colors = [
    '#F2A9D2',
    '#E376B4',
    '#C381E0',
    '#A56FBE',
    '#908DDE',
    '#89A3DE',
    '#608BED',
    '#60ACED',
    '#85CEE5',
    '#7AE3AA',
    '#97E58A',
    '#96C46F',
    '#6C9846',
    '#D5EA36',
    '#F7E729',
    '#FAD853',
    '#FA9A53',
    '#B97A4C',
    '#A58250',
    '#A53434',
  ];
  selectedColor: string = this.data.selectedColor;
  constructor(
    private dialogRef: MatDialogRef<ColorSelectionModalComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      selectedColor: string;
    }
  ) {}

  closeDialog(): void {
    this.dialogRef.close();
  }

  selectColor(color: string) {
    this.selectedColor = color;
  }

  saveColor() {
    this.dialogRef.close(this.selectedColor);
  }
}
